import { RefreshCwIcon } from "lucide-react";
import { useStore } from "@/stores/useStore";

export const LabelSyncStatus = () => {
  const { labelSyncStatus } = useStore();
  const inFlightCount = labelSyncStatus?.inFlightCount ?? 0;

  if (inFlightCount <= 0) return null;

  return (
    <div className="flex flex-row items-center gap-1.5 text-sm text-muted-foreground">
      <RefreshCwIcon size={16} className="animate-spin" />
      <span>
        {inFlightCount} label{inFlightCount === 1 ? "" : "s"} syncing...
      </span>
    </div>
  );
};
